import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import App from "./App";
import theme from "./theme/theme"; // Ensure correct path
import "./index.css";

console.log("MUI Theme Loaded:", theme); // Debugging theme application

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Ensures global MUI styles are applied */}
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
